import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AppointView from '../views/AppointView.vue'
import HomeViewItem from '../views/HomeViewItem.vue'
import HomeViewDept from '../views/HomeViewDept.vue'
import indexHome from '../views/indexHome.vue'
import Reserve from "@/views/Reserve"
Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/my',
    name: 'home',
    component: HomeView
  },
  {
    path: '/appoint',
    name: 'appoint',
    component: AppointView
  },
  {
    path: '/HomeViewDept',
    name: 'HomeViewDept',
    component: HomeViewDept
  },
  {
    path: '/HomeViewItem',
    name: 'HomeViewItem',
    component: HomeViewItem
  },
  {
    path: "/indexHome",
    name: 'indexHome',
    component: indexHome
  },
  {
    path: "/reserve",
    name: 'reserve',
    component: Reserve
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
